module.exports = __webpack_public_path__ + "static/media/student-handbook.bea987c2.pdf";